import { LeftContentContainer, RightContentContainer, SignupContainer, LandingText, ContentContainer } from './styled';
import { RadialBackground } from '../styled';
import SignUpInfo from './SignUpInfo';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import parse from 'html-react-parser';
import { en } from '../../../i18n';
import SignUpForm from './SignUpForm';
import { useSeoTags, useRemoveChatWidget } from '../../hooks';
import { useLocation } from 'react-router-dom';

const {
  signUp: { banner },
} = en;

interface IRouteState {
  text?: string;
}
const Signup = () => {
  useRemoveChatWidget();
  const theme = useTheme();
  const location = useLocation<IRouteState>();
  const isMedium = useMediaQuery(theme.breakpoints.down('md'));
  const seo = useSeoTags({ pageName: 'signup' });

  const { state } = location;

  // const leftContentText = state?.text || banner;
  const leftContentText = banner;

  const renderRightContent = () => {
    if (isMedium) return null;
    return (
      <RightContentContainer>
        <SignUpForm />
      </RightContentContainer>
    );
  };

  const renderLeftContent = () => {
    return (
      <LeftContentContainer>
        <RadialBackground>
          <ContentContainer>
            <LandingText>{parse(leftContentText)}</LandingText>
            {isMedium && <SignUpForm />}
            {/* <SignUpInfo /> */}
          </ContentContainer>
        </RadialBackground>
      </LeftContentContainer>
    );
  };

  return (
    <SignupContainer>
      {seo}
      {renderLeftContent()}
      {renderRightContent()}
    </SignupContainer>
  );
};

export default Signup;
